import { mapResponsablesToDTO } from './mapResponsablesToDTO';

export const buildMultipartBody = (formData: any, estado?: number): FormData => {
    const formDataToSend = new FormData();

    const formatDate = (date: any) => {
        if (!date) return null;
        return new Date(date).toISOString();
    };

    const payload: any = {
        idTipoResolucion: formData.idTipoResolucion ? Number(formData.idTipoResolucion) : null,
        idProvincia: formData.idProvincia ? Number(formData.idProvincia) : null,
        idLocalidad: formData.idLocalidad ? Number(formData.idLocalidad) : null,
        idOrganismoCentral: formData.idOrganismoCentral
            ? Number(formData.idOrganismoCentral)
            : null,

        latitud: formData.latitud ?? '',
        longitud: formData.longitud ?? '',

        calleRuta: formData.calleRuta ?? '',
        numeroKm: formData.numeroKm ?? '',
        departamento: formData.departamento ?? '',
        descripcionObra: formData.descripcionObra ?? '',

        superficieM2:
            formData.superficieM2 !== undefined && formData.superficieM2 !== null
                ? Number(formData.superficieM2)
                : null,
        cantidadPlantas:
            formData.cantidadPlantas !== undefined && formData.cantidadPlantas !== null
                ? Number(formData.cantidadPlantas)
                : null,
        codigoPostal: formData.codigoPostal ? Number(formData.codigoPostal) : null,

        fechaInicio: formatDate(formData.fechaInicio),
        fechaFin: formatDate(formData.fechaFin),
        fechaPresentacionPrograma: formatDate(formData.fechaPresentacionPrograma),

        programaSeguridadPresentado:
            !!formData.pdfProgramaUrl || formData.pdfPrograma instanceof File,

        ...(estado !== undefined ? { estado } : {})
    };

    if (formData.responsables && formData.responsables.length > 0) {
        payload.responsables = mapResponsablesToDTO(formData.responsables);
    }

    if (formData.contratistas && formData.contratistas.length > 0) {
        payload.contratistas = formData.contratistas;
    }

    if (formData.avisosObraTiposSubtipos && formData.avisosObraTiposSubtipos.length > 0) {
        payload.avisosObraTiposSubtipos = formData.avisosObraTiposSubtipos;
    }

    if (
        formData.avisosObraActividadesEspeciales &&
        formData.avisosObraActividadesEspeciales.length > 0
    ) {
        payload.avisosObraActividadesEspeciales = formData.avisosObraActividadesEspeciales;
    }

    if (formData.descripcionActividad && formData.descripcionActividad.trim() !== '') {
        payload.descripcionActividad = formData.descripcionActividad;
    }

    formDataToSend.append('data', JSON.stringify(payload));

    if (formData.pdfPrograma instanceof File) {
        formDataToSend.append('file', formData.pdfPrograma);
    }

    return formDataToSend;
};
